// The language the names of a tenant's data (categories, products, characteristics...) are shown and edited in first:
// the default language of the tenant (it comes with the login and `users/me`). One that is not enabled (any more) is not
// used; with no list loaded yet the default language alone, and "en" only when there is nothing else.
export function resolveDefaultLanguage(state) {
  const codes = (state?.languages ?? []).map((language) => language.code);
  const chosen = state?.defaultLanguage ?? null;
  if (chosen && (codes.length === 0 || codes.includes(chosen))) {
    return chosen;
  }

  return codes[0] ?? chosen ?? "en";
}
